import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ExportButton } from '../shared/ExportButton';

interface IshikawaHeaderProps {
    incidentId?: string;
    incident: any;
}

export const IshikawaHeader: React.FC<IshikawaHeaderProps> = ({ incidentId, incident }) => {
    return (
        <div className="mb-6">
            {incidentId && (
                <Link
                    to={`/fracas/${incidentId}`}
                    className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Back to incident
                </Link>
            )}

            <h1 className="text-3xl font-bold text-gray-900 mb-2">Ishikawa Diagram (Fishbone)</h1>
            <p className="text-gray-600">
                Identify potential causes across 6 key categories
            </p>

            {incident && (
                <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm font-medium text-blue-900">
                        Linked to: {incident.fracasNumber} - {incident.title}
                    </p>
                </div>
            )}

            <div className="mt-4 flex justify-end">
                <ExportButton
                    elementId="ishikawa-diagram"
                    fileName={`Ishikawa_Diagram_${incident?.fracasNumber || 'new'}`}
                    title="Ishikawa (Fishbone) Diagram"
                    formats={['png', 'pdf']}
                />
            </div>
        </div>
    );
};
